import { Component, OnInit } from '@angular/core';

import { LiteralsWords } from './../../i18n/literals.model';
import { LiteralsService } from './../../shared/services/literals-service';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../features/purchase-requests/shared/services/menu.service';
import { TemporaryStorageService } from 'src/app/shared/services/temporary-storage.service';

@Component({
    selector: 'tgc-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit{

  literals: LiteralsWords = this.literalsService.getLiterals();

  user: string = '';

  constructor(private literalsService: LiteralsService,
    private activatedRoute: ActivatedRoute,
    private menuService: MenuService,
    private temporaryStorageService: TemporaryStorageService,
    private router: Router,
    ) {
      this.user = (`${this.literals?.str0097} ${sessionStorage.getItem('user')}` || 'User');
  }

  ngOnInit(): void {
    const routine: string = this.temporaryStorageService.getValue('routine');

    this.menuService.loading(false); //-- Desativa loading dos resolvers, é ativado no login.component

    this.activatedRoute?.data?.forEach(element => {
      if (element?.fieldsSC1?.items) {
        this.temporaryStorageService.setValue('fieldsPropertiesSC1', element.fieldsSC1);
      }
      if (element?.fieldsDHU?.items) {
        this.temporaryStorageService.setValue('fieldsPropertiesDHU', element.fieldsDHU);
      }
      if (element?.fieldsSC8) {
        this.temporaryStorageService.setValue('structSC8', element.fieldsSC8);
      }
      if (element?.structSC1) {
        this.temporaryStorageService.setValue('structSC1', element.structSC1);
      }
      if (element?.structDHU) {
        this.temporaryStorageService.setValue('structDHU', element.structDHU);
      }
      if (element?.structDHL) {
        this.temporaryStorageService.setValue('structDHL', element.structDHL);
      }
      if (element?.structSA2) {
        this.temporaryStorageService.setValue('structSA2', element.structSA2);
      }
      if (element?.structSCR) {
        this.temporaryStorageService.setValue('structSCR', element.structSCR);
      }
      if (element?.structWF7) {
        this.temporaryStorageService.setValue('structWF7', element.structWF7);
      }
      if (element?.structSC7) {
        this.temporaryStorageService.setValue('structSC7', element.structSC7);
      }
      if (element?.structDBL) {
        this.temporaryStorageService.setValue('structDBL', element.structDBL);
      }
      if (element?.structDHM) {
        this.temporaryStorageService.setValue('structDHM', element.structDHM);
      }
      if (element?.structDHK) {
        this.temporaryStorageService.setValue('structDHK', element.structDHK);
      }
      if (element?.structSAL) {
        this.temporaryStorageService.setValue('structSAL', element.structSAL);
      }
      if (element?.structSAK) {
        this.temporaryStorageService.setValue('structSAK', element.structSAK);
      }

      if (element?.validateRoutine) {
        this.temporaryStorageService.setValue('validateRoutine', element.validateRoutine);
      }
    });

    this.temporaryStorageService.setValue('paramAltpDoc', sessionStorage['paramAltpDoc'] == 'true');
    this.temporaryStorageService.setValue('paramDtReceb', sessionStorage['paramDtReceb'] == 'true');
    this.temporaryStorageService.setValue('nfcWfCustom', sessionStorage['nfcWfCustom'] == 'true');
    this.temporaryStorageService.setValue('paramMultiBranch', sessionStorage['paramMultiBranch'] == 'true');

    if (routine === 'COMA230') {
      this.router.navigate([`/substituicao-aprovador`]);
    } else if (routine === 'COMA240') {
      this.router.navigate([`/lista-grupo-aprovacao`]);
    }

  }

}
